import React from 'react';
import { StyledRankNumber } from '../index.style';

const RankNumber = ({ rank }) => <StyledRankNumber>{rank}</StyledRankNumber>;

export default RankNumber;
